// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"c668ca65","779":"b85b788d","881":"e508e1fd","900":"ce9d9699"}[chunkId] + ".chunk.js";
};